import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/shared/shared.module';
import { AboutComponent } from "./components/about/about.component";
import { TeacherComponent } from "./components/teacher/teacher.component";

@Component({
  selector: 'app-about-us',
  imports: [SharedModule, TranslateModule, AboutComponent, TeacherComponent],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent {

}
